import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { fileResourceUrl } from '../../utils/urlUtils';
import Track from './Track';

const ImageContainerDiv = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  opacity: 1;
  & > img {
    width: 100%;
    height: 100%;
  }
`;

export default function ImageContainer(props: { monitor: string }) {
  const { monitor } = props;
  const tacsitBackground = useSelector(
    (state: any) => state.executor.tacsitBackground
  );
  const currentBackground = tacsitBackground[monitor];
  const resources = useSelector((state: any) => state.resources);
  const token = useSelector((state: any) => state.authenticate.token);
  const tracks = useSelector((state: any) => state.executor.tracks);
  const isOffline = useSelector(
    (state: any) => state.resources.offlineMode
  );
  const [url, setUrl] = useState('');
  useEffect(() => {
    if (
      currentBackground &&
      Object.keys(currentBackground).length > 0 &&
      resources
    ) {
      if (resources[currentBackground.asset]) {
        const { filename, value } = resources[currentBackground.asset];
        setUrl(fileResourceUrl(token, value, filename, isOffline));

        return;
      }
    }
    setUrl('');
  }, [currentBackground, resources, token]);
  return url ? (
    <div data-area="tascit-image-area">
      <ImageContainerDiv>{url && <img src={url} />}</ImageContainerDiv>
    </div>
  ) : null;
}
